appConfig = {
  "mobicip": {
    "title": "Mobicip",
    "routesRestricted": false,
    "favicon": "/favicon.ico",
    "css_classes": {
      "logo": "mobicip_logo",
      "signup_downloads_link": ""
    },
    "navMenuSettings": {
      "dashboard": true,
      "socialMedia": true,
      "locator": true,
      "scheduling": true
    },
    "featureSettings": {
      "myProfile": true,
      "familyLocator": true,
      "parenting": true,
      "referFriend": true,
      "feedback": true,
      "support": true,
      "about": true
    },
    "childDashboard": {
      "feedback": true
    },
    "purchaseSettings": {
      "plan": true,
      "showUpgradeButton": true,
      "showTrial": true,
      "license": false
    },
    "signup": {
      "showAwards": true,
      "showActivationCode": false
    },
    "familySharingSupport": {
      "showTitles": true,
      "showCallSchedule": true
    },
    "platformsAllowed": {
      "ios": true,
      "android": true,
      "macos": true,
      "windows": true,
      "kindle": true,
      "chromebook": true
    },
    "analytics": {
      "googleAnalytics": true,
      "plausibleAnalytics": true,
      "tapfiliate": true
    },
    "support_email":"support@prgr.in",
    "livechat": true
  },
  "zoobly": {
    "title": "Zoobly",
    "routesRestricted": true,
    "favicon": "/zoobly_favicon.png",
    "css_classes": {
      "logo": "zoobly_logo",
      "signup_downloads_link": "downloads_centered",
    },
    "navMenuSettings": {
      "dashboard": true,
      "socialMedia": false,
      "locator": true,
      "scheduling": true
    },
    "featureSettings": {
      "myProfile": true,
      "familyLocator": true,
      "parenting": false,
      "referFriend": false,
      "feedback": false,
      "support": false,
      "about": true
    },
    "childDashboard": {
      "feedback": false
    },
    "purchaseSettings": {
      "plan": false,
      "showUpgradeButton": false,
      "showTrial": false,
      "license": true
    },
    "signup": {
      "showAwards": false,
      "showActivationCode": true
    },
    "familySharingSupport": {
      "showTitles": false,
      "showCallSchedule": false
    },
    "platformsAllowed": {
      "ios": true,
      "android": true,
      "macos": false,
      "windows": true,
      "kindle": false,
      "chromebook": false
    },
    "download_links": {
      "android": "https://play.google.com/store/apps/details?id=mobicip.com.safeBrowserff",
      "windows": "https://mobicipdownloads.s3.us-east-1.amazonaws.com/windows8/merlin/amd64/MobicipInstaller_x64_4_2_549.exe",
      "ios": "https://apps.apple.com/us/app/parental-control-app-mobicip/id299153586"
    },
    "analytics": {
      "googleAnalytics": false,
      "plausibleAnalytics": false
    },
    "support_email":"support@zoobly.in",
    "livechat": false
  }
};

(function () {
  const hostname = window.location.hostname;

  const configKey = Object.keys(appConfig).find(key =>
    hostname.includes(key)
  );

  window.APP_CONFIG = configKey ? appConfig[configKey] : appConfig['mobicip'];
})();